import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthShell } from "@/components/AuthShell";
import { Field, PageLoader } from "@/components/kit";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AcceptInvite() {
  const { token } = useParams();
  const [invite, setInvite] = useState(null);
  const [loadErr, setLoadErr] = useState("");
  const [f, setF] = useState({ name: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    api.get(`/auth/invite/${token}`)
      .then((r) => { setInvite(r.data); setF((x) => ({ ...x, name: r.data.name })); })
      .catch((e) => setLoadErr(errMsg(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post(`/auth/invite/${token}/accept`, f);
      setUser(data.user);
      nav(data.role === "admin" ? `/manage/${data.team_id}` : `/t/${data.slug}/players`, { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (loadErr) return <AuthShell title="Invite not found" subtitle={loadErr}><p className="text-slate-400" data-testid="invite-error">Ask your team admin to resend your invite.</p></AuthShell>;
  if (!invite) return <PageLoader />;

  return (
    <AuthShell title={`Join ${invite.team_name}`} subtitle={`You've been invited as ${invite.role === "admin" ? "a team admin" : "a player"}. Finish setting up your account.`}>
      <form onSubmit={submit} className="space-y-5" data-testid="invite-form">
        <Field label="Email"><Input value={invite.email} disabled data-testid="invite-email" /></Field>
        <Field label="Your name"><Input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="invite-name-input" /></Field>
        <Field label={invite.account_exists ? "Your existing password" : "Choose a password"} hint={invite.account_exists ? "You already have a SportsDiary account — we'll link this team to it." : "At least 8 characters"}>
          <Input type="password" required minLength={8} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="invite-password-input" />
        </Field>
        {error && <p className="text-sm text-rose-400" data-testid="invite-submit-error">{error}</p>}
        <Button type="submit" disabled={busy} className="h-11 w-full rounded-full font-bold uppercase tracking-wider" data-testid="invite-submit-btn">
          {busy ? "Joining…" : "Complete registration"}
        </Button>
      </form>
    </AuthShell>
  );
}
